export const gray = '#7C7C7C'
export const pink = '#FB7185'
export const blue = '#073c7a'
